import React from 'react';
import { cn } from '@/shared/utils/shadcn';

const Eb3AdvantageItem = ({
  className,
  index,
  title,
  content,
  itemPosition = 'left',
}: {
  className?: string;
  index: number;
  title: string;
  content: string;
  itemPosition?: string;
}) => {
  return (
    <div
      className={cn('relative w-[20.8vw] rounded-[20px] bg-[#F5F5FF] px-[1.3vw] pb-[2.184vw] pt-[1.816vw]', className)}
    >
      <div className="mb-[0.884vw] text-[1.04vw] font-semibold text-[#171A7E]">{title}</div>
      <div className="text-[0.78vw] leading-[1.144vw] text-[#333333cc]">{content}</div>
      <div
        className={cn(
          'absolute flex size-[2.288vw] flex-row items-center justify-center rounded-[10px] bg-[#4D26CC] text-[1.04vw] font-semibold text-white',
          {
            '-right-[1.144vw]': itemPosition === 'left',
            'bottom-0': itemPosition === 'left',
            '-left-[1.144vw]': itemPosition === 'right',
            'top-0': itemPosition === 'right',
          },
        )}
      >
        0{index + 1}
      </div>
    </div>
  );
};

export default Eb3AdvantageItem;
